export default __webpack_public_path__ + "static/media/signal_6.7f24b81c.mp3";